const content = {
  title: "Passive Voice (All Tenses & Advanced Use)",
  explanation: `
At B2 level, Passive Voice is a discourse tool for controlling information focus.
Example: The policy was approved yesterday.

It foregrounds the action, process, or result instead of the agent.
Example: The data was collected over six months.

Use it when the doer is unknown, irrelevant, obvious, or intentionally hidden for objectivity.
Example: Several mistakes were made during the experiment.

Passive structures are frequent in reports, scientific writing, and formal announcements.
Example: The findings have been published in an international journal.
  `,
  rules: [
    "Basic structure: subject + be + past participle (V3)",
    "The tense is shown through the verb 'be'",
    "Passive forms exist in all main tenses, including perfect and continuous",
    "Use 'by' to mention the agent only if it adds important information",
    "Omitting the agent is common in formal and academic contexts",
    "Passive voice is often used to sound neutral, formal, or impersonal"
  ],
  examples: [
    "The letter is written every day. (present simple passive)",
    "The house was built in 1995. (past simple passive)",
    "The report has been completed. (present perfect passive)",
    "The meeting will be held tomorrow. (future passive)",
    "The experiment is being conducted carefully. (continuous passive)",
    "The decision was made by the committee. (agent included)"
  ]
};

export default content;


